import React, { useEffect, useState } from 'react';
import { Checkbox, Modal, Select, Tooltip } from 'antd';
import { Button, ColumnProps, Table, notification } from '@digital/ui';
import { DesfazerExclusoesHandOverOrdemCompra, HandOverOrdemCompra, HandoverArquivo, getDocumentosOrdemCompraHandover, updateSasDocumentoOrdemCompraCommand } from '@app/api/sas/sasDocumentoOrdemCompra';
import { Visibility } from '@app/components';
import { useRecoilValue } from 'recoil';
import { dadosGeraisState, ordemCompraIdState } from '../atoms';
import { hasPermission } from '@app/helpers/permissions';
import { isObjEmpty } from '@app/helpers/objHelper';
import { EStatusAprovacaoContrato, EStatusAprovacaoContratoTotvs } from '@app/enums';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';

export interface propsModalConfirmarIntegracao {

}

const ModalConfirmarHandover = ({ }: propsModalConfirmarIntegracao) => {
  const ordemCompraId: string = useRecoilValue(ordemCompraIdState);
  const dadosGerais = useRecoilValue(dadosGeraisState);

  const [exibirModal, setExibirModal] = useState(false);
  const [exibirBotao, setExibirBotao] = useState(true);
  const [documentos, setDocumentos] = useState<{ ativos: any[] }>({ ativos: [] });
  const [arquivosHandover, setArquivosHandover] = useState<HandoverArquivo[]>([]);
  const [minutaArquivoId, setMinutaArquivoId] = useState<string | undefined>();
  const [pqArquivoId, setPqArquivoId] = useState<string | undefined>();
  const [carregandoDocumentos, setCarregandoDocumentos] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [isMultiplosGestores, setIsMultiplosGestores] = useState(false);
  const [isFaturamentoDireto, setIsFaturamentoDireto] = useState(false);
  const [isAdiantamentoFinanceiro, setIsAdiantamentoFinanceiro] = useState(false);

  const ehAditivoContrato = dadosGerais.tipoContrato && dadosGerais.tipoContrato.toLowerCase() === "contrato" &&  dadosGerais.tipo === ETipoDemanda.Aditivo;
  const ehContrato = dadosGerais.tipoContrato && dadosGerais.tipoContrato.toLowerCase() === "contrato";
  const exibirOpcoesContrato = ehContrato && !ehAditivoContrato;
  const selecaoObrigatoria = ehContrato && dadosGerais.tipo === ETipoDemanda.NovaContratacao;
  const selecaoCompleta = !!minutaArquivoId && !!pqArquivoId && minutaArquivoId !== pqArquivoId;
  const aditivoComIntegracaoTotvs = dadosGerais.isPrazo || dadosGerais.isValorSemAcrescimoEscopo;
  const isDisabled = ehAditivoContrato
    ? aditivoComIntegracaoTotvs && (!dadosGerais.contratoEmitido || dadosGerais.statusAprovacaoAditivoTotvs !== EStatusAprovacaoContratoTotvs.APROVADO)
    : !dadosGerais.contratoEmitido || isObjEmpty(dadosGerais.contratoId) || dadosGerais.handover;

  const montarMotivoHandoverDesabilitado = (): string => {
    if (!exibirBotao) {
      return "Handover já foi realizado para esta Ordem de Compra.";
    }

    if (dadosGerais.handover === true) {
      return "Handover já foi realizado para esta Ordem de Compra.";
    }

    if (ehAditivoContrato && aditivoComIntegracaoTotvs) {
      if (!dadosGerais.contratoEmitido) {
        return "Aguarde a emissão do contrato no TOTVS antes de realizar o Handover.";
      }
      if (dadosGerais.statusAprovacaoAditivoTotvs !== EStatusAprovacaoContratoTotvs.APROVADO) {
        return "Aguarde a aprovação do aditivo no TOTVS antes de realizar o Handover.";
      }
    }

    if (!ehAditivoContrato) {
      if (!dadosGerais.contratoEmitido) {
        return "Aguarde a emissão do contrato no TOTVS antes de realizar o Handover.";
      }
      if (isObjEmpty(dadosGerais.contratoId)) {
        return "O contrato foi emitido no TOTVS, mas ainda não foi integrado ao SGC. Tente novamente mais tarde.";
      }
    }

    return "Acatar";
  };

  const getDocs = () => {
    setCarregandoDocumentos(true);
    getDocumentosOrdemCompraHandover({ ordemCompraId })
      .then((data: any) => {
        const arquivos: HandoverArquivo[] = (data && data.arquivosHandover) || [];
        setDocumentos({ ativos: (data && data.ativos) || [] });
        setArquivosHandover(arquivos);
        setMinutaArquivoId(atual => arquivos.some(x => x.id === atual) ? atual : undefined);
        setPqArquivoId(atual => arquivos.some(x => x.id === atual) ? atual : undefined);
      })
      .catch(() => {
        setDocumentos({ ativos: [] });
        setArquivosHandover([]);
        setMinutaArquivoId(undefined);
        setPqArquivoId(undefined);
        notification.error('Não foi possível carregar os arquivos do handover. Feche e tente novamente.');
      })
      .finally(() => setCarregandoDocumentos(false));
  }

  const onChangeHandover = (documentoId: string, handover: boolean) => {
    updateSasDocumentoOrdemCompraCommand({
      sasDocumentoOrdemCompraId: documentoId,
      handover: handover
    }).then(data => {
      if (data) getDocs()
    })
  }

  const onDesfazer = () => {
    DesfazerExclusoesHandOverOrdemCompra(ordemCompraId).then(data => {
      getDocs();
    });
  }

  useEffect(() => {
    exibirModal && getDocs();
  }, [exibirModal])

  const handleConfirm = () => {
    if (enviando || carregandoDocumentos || (selecaoObrigatoria && !selecaoCompleta)) return;
    setEnviando(true);
    return HandOverOrdemCompra(ordemCompraId, {
      minutaArquivoId: selecaoObrigatoria ? minutaArquivoId : undefined,
      pqArquivoId: selecaoObrigatoria ? pqArquivoId : undefined,
      isMultiplosGestores: exibirOpcoesContrato && isMultiplosGestores,
      isFaturamentoDireto: exibirOpcoesContrato && isFaturamentoDireto,
      isAdiantamentoFinanceiro: exibirOpcoesContrato && isAdiantamentoFinanceiro,
    }).then(data => {
      if (data && data.valid) {
        setExibirBotao(false);
        setExibirModal(false);
      }
    }).catch(() => notification.error('Não foi possível confirmar o handover. Tente novamente.'))
      .finally(() => setEnviando(false));
  };

  const columns = () => {
    let columns: ColumnProps<any>[] = [];

    columns.push({
      title: 'Descrição',
      dataIndex: 'descricao',
    })

    columns.push({
      title: 'Arquivo',
      dataIndex: 'arquivoNomeDownload',
      width: '30%'
    })

    return columns;
  }

  const handoverBloqueado = isDisabled || !exibirBotao || dadosGerais.handover == true;

  return (
    <>
      <Visibility /*visible={exibirBotao}*/>
        <Tooltip title={montarMotivoHandoverDesabilitado()}>
          <span style={{ display: 'inline-block', marginRight: '5px', cursor: handoverBloqueado ? 'not-allowed' : undefined }}>
            <Button
              className='button-sas-acoes'
              style={{ pointerEvents: handoverBloqueado ? 'none' : undefined }}
              type='primary'
              onClick={() => {
                setMinutaArquivoId(undefined);
                setPqArquivoId(undefined);
                setArquivosHandover([]);
                setDocumentos({ ativos: [] });
                setIsMultiplosGestores(false);
                setIsFaturamentoDireto(false);
                setIsAdiantamentoFinanceiro(false);
                setExibirModal(true);
              }}
              disabled={handoverBloqueado}
            >
              Handover
            </Button>
          </span>
        </Tooltip>
      </Visibility>
      <Modal
        title="Handover"
        // className="chat-modal"
        width="1200px"
        visible={exibirModal}
        closable={!enviando}
        maskClosable={!enviando}
        onCancel={() => {
          if (!enviando) setExibirModal(false);
        }}
        footer={<>
          <Visibility visible={false}>
            <Tooltip title="Desfaz todas as exclusões do handover" >
              <Button title='Desfazer' type='link' onClick={() => onDesfazer()} />
            </Tooltip>
          </Visibility>
          <Visibility
            visible={hasPermission(["SAS_ORDENS_COMPRA_SUBSTITUIR_ANEXO"])}
          >
          </Visibility>
          <Button
            title='Fechar'
            type='link'
            disabled={enviando}
            onClick={() => setExibirModal(false)}
          />
          <Button title='Confirmar' type='primary' loading={enviando}
            disabled={carregandoDocumentos || enviando || (selecaoObrigatoria && !selecaoCompleta)} onClick={() =>
            Modal.confirm({
              title: 'Confirmar Handover',
              content:
                'Deseja copiar todos os documentos para o SGC?',
              cancelText: 'Cancelar',
              okText: 'Confirmar',
              onOk: handleConfirm,
            })
          } />
        </>}>
        <Table
          dataSource={documentos.ativos}
          columns={columns()}
          pagination={false}
          loading={carregandoDocumentos}
        />
        {selecaoObrigatoria && (
          <section aria-label="Documentos para ativação" style={{ marginTop: '24px' }}>
            <p>Para nova contratação, selecione a minuta e a PQ entre os arquivos que serão enviados ao SGC.</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
              <div style={{ flex: '1 1 280px', minWidth: 0 }}>
                <label htmlFor="handover-minuta">Minuta (PDF) — obrigatória</label>
                <Select<string> id="handover-minuta" aria-required="true" value={minutaArquivoId}
                  onChange={setMinutaArquivoId} placeholder="Selecione a minuta"
                  loading={carregandoDocumentos} disabled={carregandoDocumentos || enviando}
                  style={{ width: '100%' }}>
                  {arquivosHandover.filter(x => (x.extensao || '').replace(/^\./, '').toLowerCase() === 'pdf')
                    .map(x => <Select.Option key={x.id} value={x.id}>{x.nome}</Select.Option>)}
                </Select>
                {!carregandoDocumentos && !arquivosHandover.some(x => (x.extensao || '').replace(/^\./, '').toLowerCase() === 'pdf') && (
                  <p role="status">Inclua um PDF nos documentos do handover para selecionar a minuta.</p>
                )}
              </div>
              <div style={{ flex: '1 1 280px', minWidth: 0 }}>
                <label htmlFor="handover-pq">PQ (XLSX) — obrigatória</label>
                <Select<string> id="handover-pq" aria-required="true" value={pqArquivoId}
                  onChange={setPqArquivoId} placeholder="Selecione a PQ"
                  loading={carregandoDocumentos} disabled={carregandoDocumentos || enviando}
                  style={{ width: '100%' }}>
                  {arquivosHandover.filter(x => (x.extensao || '').replace(/^\./, '').toLowerCase() === 'xlsx')
                    .map(x => <Select.Option key={x.id} value={x.id}>{x.nome}</Select.Option>)}
                </Select>
                {!carregandoDocumentos && !arquivosHandover.some(x => (x.extensao || '').replace(/^\./, '').toLowerCase() === 'xlsx') && (
                  <p role="status">Inclua uma planilha XLSX nos documentos do handover para selecionar a PQ.</p>
                )}
              </div>
            </div>
          </section>
        )}
        {exibirOpcoesContrato && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '24px' }}>
            <Checkbox
              checked={isMultiplosGestores}
              onChange={event => setIsMultiplosGestores(event.target.checked)}
            >
              Contrato com múltiplos gestores
            </Checkbox>
            <Checkbox
              checked={isFaturamentoDireto}
              onChange={event => setIsFaturamentoDireto(event.target.checked)}
            >
              Contrato com faturamento direto
            </Checkbox>
            <Checkbox
              checked={isAdiantamentoFinanceiro}
              onChange={event => setIsAdiantamentoFinanceiro(event.target.checked)}
            >
              Contrato com adiantamento financeiro
            </Checkbox>
          </div>
        )}
      </Modal>
    </>
  );
};
export default ModalConfirmarHandover;
